module.exports = __webpack_public_path__ + "img/logo.9682e93c.jpg";